module.exports = "<!-- <form class=\"sidebar-form\"></form> -->\n"


//////////////////
// WEBPACK FOOTER
// D:/desv/producao/ITN/srvHCWaba/src/app/components/app-sidebar-form/app-sidebar-form.component.html
// module id = ../../../../../src/app/components/app-sidebar-form/app-sidebar-form.component.html
// module chunks = main